import useSWR, { SWRResponse } from 'swr';

import { prepareConditionalSwrArgs } from 'hooks/prepare-conditional-swr-args';
import { DistributorPriceService } from 'services/DistributorPriceService';

import type { ComponentPricing } from '@/payload-types';

const useDistributorPricesByComponentIds = (
    componentIds?: string[],
): SWRResponse<ComponentPricing[]> & {
    priceFor: (componentId: string) => ComponentPricing | null;
    pricesFor: (componentId: string) => ComponentPricing[];
} => {
    const key = DistributorPriceService.swr.products(componentIds ?? []);
    const fetcher = () => DistributorPriceService.getMultiple(componentIds ?? []);

    const swr = useSWR(
        ...prepareConditionalSwrArgs({
            key,
            fetcher,
            condition: !!componentIds?.length,
        }),
        {
            revalidateOnFocus: true,
            keepPreviousData: true,
        },
    );

    const cheapestFirstByComponent = DistributorPriceService.cheapestFirstByComponent(swr.data ?? []);

    const pricesFor = (componentId: string): ComponentPricing[] => cheapestFirstByComponent.get(componentId) ?? [];
    const priceFor = (componentId: string): ComponentPricing | null => pricesFor(componentId)[0] ?? null;

    return {
        ...swr,
        priceFor, // cheapest
        pricesFor, // all prices sorted by price
    };
};

export { useDistributorPricesByComponentIds };
